import React from 'react';
import { Box, Typography } from '@mui/material';
import { WarningAmber } from '@mui/icons-material';

const AccessDenied403 = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300, p: 4 }}>
    <WarningAmber sx={{ fontSize: 64, color: '#DC143C', mb: 2 }} />
    <Typography variant="h4" sx={{ color: '#DC143C', fontWeight: 'bold', mb: 1 }}>403 - Access Denied</Typography>
    <Typography variant="body1" color="textSecondary" align="center">
      You do not have permission to view this page.<br />
      Please contact your administrator if you believe this is a mistake.
    </Typography>
  </Box>
);

export default AccessDenied403; 